import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { NNEvidenceCreateForm } from "@/features/nn-evidence/NNEvidenceCreateForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useLocation, useParams } from "react-router-dom";

export function NNEvidenceCreate() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { state } = useLocation();

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            href: state?.from ? state.from : `/rfs/rfs/${id}`,
            label: "Detail",
          },
          {
            href: `/rfs/rfs/${id}/nn-evidence/create`,
            label: "Create NN Evidence",
          },
        ]}
      />
      <NNEvidenceCreateForm />
    </>
  );
}
